import React from 'react';
import ZProps from "./zprops";
import ZLog from "./zlog";
import ZNetwork from "./znetwork";
import ZUtil from "./zutil";
import AMC from "./AMC";
import { APP } from "./App";
import ZAPI from "./zapi";
import {ROUTER} from "./AMCRouter";
import AMCConstants from "./AMCConstants";
import RockPanel from "./RockPanel";
import RockWorkspace from "./RockWorkspace";
import ZEaser from './zeaser';
import PleaseStandBy from "./PleaseStandBy";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAsterisk, faBolt, faTerminal, faExclamationTriangle, faExclamationCircle, faWifi, faExpandArrowsAlt, faCompressArrowsAlt, faUserGraduate, faBan, faPlay, faCheck, faUndoAlt, faRedoAlt, faCopy, faPaste, faTrashAlt, faCut, faList, faExternalLinkAlt, faChevronUp, faChevronDown, faFolderOpen, faClone, faShareSquare, faTimes, faCodeBranch } from '@fortawesome/free-solid-svg-icons'
import { faClock } from '@fortawesome/free-regular-svg-icons'
import { ROCK_PILE_INDEX_STYLES, ROCK_STYLES, ROCK_IO_PORT_SHAPES, ROCK_IO_PORT_GENERICS } from './AMCConstants';

export default class RockstarEditor extends React.Component {
	constructor(props) {
		super(props);
		this.MAX_NAV_WIDTH = 50;
		this.state = { nav_width: 25 };
		this.interactors = [];
		this.accel_keys = [];
		this.panes = [ { left: 0, right: 25 }, { left: 25, right: 50 }, { left:50, right: 75 }, { left: 75, right: 100 } ];
	}
	componentDidMount() {
		let { service } = this.props;
		this.cookies = JSON.parse(ZUtil.getCandy("rockstareditor") || '{}');
		if (this.cookies.service_uri !== service.uri + ":" + service.version) {
			this.cookies = { opened: {}, service_uri: service.uri + ":" + service.version, inspector_open: this.cookies.inspector_open, selected_panel: this.cookies.selected_panel };
			this.onExpandAll();
		}
if (!this.cookies.inspector_open) {
ZLog.log("this.cookies=", { cookies: this.cookies});
//this.callsomethingfake();
}
		this.setState(this.cookies); 
		this.accel_keys.push(APP.registerAcceleratorKey("ctrlKey", "i", this.showInspector));
		ZProps.set("selected_rock_uri", this.cookies.selected_rock_uri || null);

		if (!this.resizer) {
			this.resizer = new DragResizeWindow("rockstar-editor-container", AMCConstants.RESIZABLE_PANEL_CLASSNAME, "left", () => {
				this._updateCandies();
			}).enable()
		}

		// Exit here for uneditable components
		if (!AMC.isEditable(service)) {
			return;
		}

		this.listener = ZProps.addListener("drop_source_placeholder_uri", (name, value, oldvalue) => {
			if (value) {
				let { node } = this.props.graphman.getContainerNodeAndIndex(value);
				ZProps.sett("drop_source_placeholder_node", node);
			}
			this.forceUpdate();
		});
		this.listener2 = ZProps.addListener("drop_target_placeholder_uri", (name, value, oldvalue) => {
			this.forceUpdate();
		});
		this.listener3 = ZProps.addListener("ninja", (name, value, oldvalue) => {
			switch (value) {
				case "inspector" :
					this.showInspector(true);
					break;
				default:
					this.forceUpdate();
					break;
			}
		});
		this.interactors.push(
			new DeleteHandler(document.body, () => {
				this.onRockDelete();
			}).enable()
		);
		RockSanityCheck.init(service);
		this.interactors.push(
			new DragAndDropMove(document.body, "DragAndDropMovable", (e, x, y) => {
				// ----------
				// PICKUP
				// ----------
				this.showDropSource(e.getAttribute("data-uri"), x, y);
			}, (e, x, y) => {
				// ----------
				// DRAG
				// ----------
				this.showDropTarget(e.getAttribute("data-uri"), x, y);
			}, (e, x, y, cb) => {
				// ----------
				// DROP
				// ----------
				if (!AMC.isEditable(service) || !this.moveDroppable(e, x, y)) {
					// ----------
					// scurry home
					// ----------
					return this.scurryHome(e, cb);
				}
				return cb();
			}, (e) => {
				return !APP.isPopped();
			}).enable()
		);
		this.accel_keys.push(APP.registerAcceleratorKey("ctrlKey", "c", this.clipboardCopy));
		this.accel_keys.push(APP.registerAcceleratorKey("ctrlKey", "v", this.clipboardPaste));
		this.accel_keys.push(APP.registerAcceleratorKey("ctrlKey", "x", this.clipboardCut));
		this.accel_keys.push(APP.registerAcceleratorKey("ctrlKey", "z", this.onUndo));
		this.accel_keys.push(APP.registerAcceleratorKey("ctrlKey", "y", this.onRedo));

		this.collectValidationErrorsFromLogFile( (err, errors) => {
			this.collectValidationErrors(errors);
		});

//		ZProps.set("selected_rock_uri", this.cookies.selected_rock_uri || null);
	}
	componentWillUnmount() {
		for (var i = 0; i < this.interactors.length; ++i) {
			this.interactors[i].disable();
		}
		if (this.listener) {
			ZProps.removeListener(this.listener);
			ZProps.removeListener(this.listener2);
			ZProps.removeListener(this.listener3);
		}
		if (this.accel_keys) {
			APP.unregisterAcceleratorKeys(this.accel_keys);
		}
	}
	setService(service) {
		this.props.setService(service);
	}
	onRockDelete() {
		if (this.state.selected_rock_uri && this.isDeleteable(this.state.selected_rock_uri)) {
			let { container, node } = this.props.graphman.getContainerNodeAndIndex(this.state.selected_rock_uri);
			if (!RockSanityCheck.checkDelete(container, node)) {
				APP.areYouSure(this._onRockDelete);
			}
		}
	}
	_onRockDelete = () => {
		this.props.graphman.removePart(this.state.selected_rock_uri);
		ZProps.set("selected_rock_uri", null);
		this.onSaved();
		this.forceUpdate();
	}
	isDeleteable(uri) {
		let { service } = this.props;
		let kind = uri.split("/")[1];
		return AMC.isEditable(service) && kind !== "service" && (kind !== "pipeline" || ZProps.get(uri).purpose === "test");
	}
	deselectAll = () => {
		ZProps.set("selected_rock_uri", null);
		this.setState({ selected_rock_uri: null });
		this._updateCandies({ selected_rock_uri: null });
	}
	_updateCandies(obj) {
		let s = this.cookies;
		if (document.getElementById("rockstar-rockpile")) {
			let width = document.getElementById("rockstar-editor-container").offsetWidth;
			s.nav_width = 100 * document.getElementById("rockstar-rockpile").offsetWidth/width;
			s.nav_width = Math.min(s.nav_width, this.MAX_NAV_WIDTH);
			this.setState({ nav_width: s.nav_width });
		}
		if (obj) {
			Object.keys(obj).forEach( key => {
				if (!obj[key]) {
					delete s[key];
				} else {
					s[key] = obj[key];
				}
			});
		}
if (this.cookies.inspector_open && !s.inspector_open) {
ZLog.log("update this.cookies was=", { cookies: this.cookies});
ZLog.log("update this.cookies now=", { cookies: s});
this.callsomethingfake();
}
		this.cookies = s;
		ZUtil.setCandy("rockstareditor", JSON.stringify(s));
	}
	onCloseInspector = () => {
		let { player, onRockstarClose } = this.props;
		this.setState({ inspector_open: null });
		this._updateCandies({ inspector_open: null });
		if (player) {
			onRockstarClose();
		}
	}
	getElementByURI(uri) {
		let pickables = ZUtil.nodeListToArray(document.body.getElementsByClassName("Rock"))
		return pickables.find( p => p.getAttribute("data-uri") === uri );
	}
	scurryHome = (e, cb) => {
		let pickupsite_rect = ZProps.get("drop_source_placeholder_rect");
		if (!pickupsite_rect) {
			let uri = ZProps.get("drop_source_placeholder_uri");
			let pickupsite = this.getElementByURI(uri);
			pickupsite_rect = pickupsite.getBoundingClientRect();
		}
		let droppable_rect = ZUtil.getBoundingClientRect(e, document.body);
		new ZEaser(function(k) {
			e.style.left = (droppable_rect.left + (pickupsite_rect.left - droppable_rect.left) * k) + "px";
			e.style.top = (droppable_rect.top + (pickupsite_rect.top - droppable_rect.top) * k) + "px";
		}, function() {
			//done
			ZProps.set("drop_source_placeholder_uri", null);
			if (cb) {
				cb();
			}
		}, { duration: 1000 });
	}
	showDropSource(uri, x, y) {
		ZLog.debug("showDropSource: " + uri);
		ZProps.set("drop_source_placeholder_rect", ZUtil.getBoundingClientRect(this.getElementByURI(uri), document.body));
		ZProps.set("drop_source_placeholder_uri", uri);
	}
	showDropTarget = (droppable_uri, x, y) => {
		let { service} = this.props;
		if (!AMC.isEditable(service)) {
			return;
		}
		let editor = document.getElementById("rockstar-editor");
		let pickables = ZUtil.nodeListToArray(editor.getElementsByClassName("Rock"));
//ZLog.log("pickables:", { pickables: pickables});
		pickables = pickables.filter( p => !droppable_uri || p.getAttribute("data-uri") !== droppable_uri );
//ZLog.log("pickables:", { pickables: pickables});
		let underneath = ZUtil.pickElement(pickables.reverse(), x, y);
//console.log("underneath=" + underneath);
		let bias = "before";
		if (underneath) {
			// based on y being above or below midpoint, switch order of sanity checks bellow
			//let underneath_rect = ZUtil.getBoundingClientRect(underneath, document.body);
			let underneath_rect = underneath.getBoundingClientRect();
console.log("y=" + y);
console.log("underneath=" + underneath.id);
console.log("underneath rect=" + require("util").inspect(underneath_rect));
ZLog.log("underneath rect=", { underneath_rect: underneath_rect });
console.log("underneath.middle=" + (underneath ? (underneath_rect.top + underneath_rect.height/2) : "null") );
			if (y > underneath_rect.top + underneath_rect.height/2) {
				let next = underneath.parentNode.nextSibling;
				if (next) {
					//next.firstElement;
					next = next.firstElement;
				}
				if (next && !next.id) {
					next = null;
				}
				if (next) {
					underneath = next;
				} else {
					bias = "after";
				}
			}
console.log("bias=" + bias);
console.log("now underneath=" + (underneath ? underneath.id : "null"));
		}
		let underneath_uri = underneath ? underneath.getAttribute("data-uri") : null;
//console.log("underneath_uri=" + underneath_uri);
if (underneath) {
console.log("is over placeholder " + underneath.className.indexOf("Placeholder"));
console.log("is drop_target_placeholder_uri = " + (ZProps.get("drop_target_placeholder_uri") !== underneath_uri));
console.log("is drop_source_placeholder_uri = " + (ZProps.get("drop_source_placeholder_uri") !== underneath_uri));
}
		if (!underneath) {
			ZProps.set("drop_target_placeholder_uri", null)
		} else if (underneath.className.indexOf("Placeholder") === -1
			&& ZProps.get("drop_target_placeholder_uri") !== underneath_uri
			&& ZProps.get("drop_source_placeholder_uri") !== underneath_uri) {
			let { container, node } = this.props.graphman.getContainerNodeAndIndex(underneath_uri);
			if (container) {
				if ((ZProps.get("selected_rock_uri") === underneath_uri
					&& !RockSanityCheck.checkSelectedReplace(container, ZProps.get(droppable_uri), node))
					// e.g. dataset on a datasource
					|| !RockSanityCheck.checkSpecialReplace(container, ZProps.get(droppable_uri), node)) {
					ZProps.set("drop_target_placeholder_uri_location", "replace");
					ZProps.set("drop_target_placeholder_uri", underneath_uri);
//console.log("underneath uri=" + underneath_uri + " to be REPLACED by " + droppable_uri);
				} else if (bias === "before") {
					if (!RockSanityCheck.checkInsertBefore(container, ZProps.get(droppable_uri), node)) {
//console.log("underneath uri=" + underneath_uri + " to be BEFORE");
						ZProps.set("drop_target_placeholder_uri_location", "before");
						ZProps.set("drop_target_placeholder_uri", underneath_uri);
//					} else if (!RockSanityCheck.checkInsertAfter(container, ZProps.get(droppable_uri), node)) {
//						ZProps.set("drop_target_placeholder_uri_location", "after");
//						ZProps.set("drop_target_placeholder_uri", underneath_uri);
//console.log("underneath uri=" + underneath_uri + " to be AFTER");
					} else {
						ZProps.set("drop_target_placeholder_uri", null);
//console.log("underneath uri=" + underneath_uri + " to be NULL");
					}
				} else {
					if (!RockSanityCheck.checkInsertAfter(container, ZProps.get(droppable_uri), node)) {
						ZProps.set("drop_target_placeholder_uri_location", "after");
						ZProps.set("drop_target_placeholder_uri", underneath_uri);
//					} else if (!RockSanityCheck.checkInsertBefore(container, ZProps.get(droppable_uri), node)) {
//						ZProps.set("drop_target_placeholder_uri_location", "before");
//						ZProps.set("drop_target_placeholder_uri", underneath_uri);
					} else {
						ZProps.set("drop_target_placeholder_uri", null);
					}
				}
			}
		}
	}
	moveDroppable(e, x, y) {
		let uri = e.getAttribute("data-uri");
//console.log("moveDroppable: " + ZProps.get("drop_target_placeholder_uri") + " with " + uri);
		if (ZProps.get("drop_target_placeholder_uri") && uri !== ZProps.get("drop_target_placeholder_uri")) {
			this.props.graphman.movePart(
				ZProps.get("drop_target_placeholder_uri"), 
				uri, 
				ZProps.get("drop_target_placeholder_uri_location") !== "after");
			ZProps.set("drop_target_placeholder_uri", null);
			ZProps.set("drop_source_placeholder_uri", null);
			this.onSaved();
			return true;
		}
		// this.scurryHome(e);
		return false;
	}
	insertDroppable = (e, x, y) => {
		let { service} = this.props;
		if (AMC.isEditable(service) && ZProps.get("drop_target_placeholder_uri")) {
			let kind = e.getAttribute("data-kind");
//console.log("insertDroppable kind=" + kind);
			let new_part = { uri: kind, kind: kind, type: e.getAttribute("data-uri") }; // "core/" + kind + "/ATM" + ZUtil.capitalize(kind) };
			if (kind === "dataset") {
				new_part = ZProps.get(e.getAttribute("data-uri"));
				if (!new_part) {
					ZLog.error("Cannot find dataset instance: " + e.getAttribute("data-uri"));
					return false;
				}
				new_part.kind = "datasource";
			}
			//let { container, node, index } = this.props.graphman.getContainerNodeAndIndex(ZProps.get("drop_target_placeholder_uri"));
			//if (!RockSanityCheck.checkInsertBefore(container, new_part, node)) {
			if (ZProps.get("drop_target_placeholder_uri_location") === "replace") {
				this.props.graphman.replacePart(ZProps.get("drop_target_placeholder_uri"), new_part);
			} else {
				this.props.graphman.insertNewPart(ZProps.get("drop_target_placeholder_uri"), new_part, ZProps.get("drop_target_placeholder_uri_location") === "before");
			}
			ZProps.set("drop_target_placeholder_uri", null);
			ZProps.set("drop_source_placeholder_uri", null);
			AMC.assureSpecAndImpLoaded(new_part, err => {
				this.collectValidationErrors();
			});
			this.onSaved();
			return true;
		}
		if (!AMC.isEditable(service)) {
			APP.setError("Sorry, you do not have permssion to edit this. But you can make a clone and edit that");
		}
		this.scurryHome(e);
		return false;
	}
	onRockSelect = (uri, force, donotopenpanel) => {
		let selected = ZProps.get("selected_rock_uri") !== uri || force === true;
		ZProps.set("selected_rock_uri", selected ? uri : null);
donotopenpanel = true;
		let s = { selected_rock_uri: selected ? uri : null }; // , inspector_open: !donotopenpanel && selected };
		this.setState(s);
		this._updateCandies(s);
	}
	showInspector = (flag, toggle) => {
		ZLog.debug("showInspector: " + flag);
		flag = (flag === undefined || toggle === true) ? !this.state.inspector_open : flag;
		let panel = typeof flag === "string" ? flag : null; // this.state.selected_panel;
		this.setState({ inspector_open: flag, selected_panel: panel });
		this._updateCandies({ inspector_open: !!flag });
	}
	onSelectPanel = (panel) => {
		this.setState({ selected_panel: panel });
		this._updateCandies({ selected_panel: panel });
	}
	clipboardCut = (item) => {
		item = item || (this.state.selected_rock_uri && ZProps.get( this.state.selected_rock_uri));
		if (item) {
			ZProps.set("clipboard", item);
			this.deleteItem(item);
		}
	}
	clipboardCopy = (item) => {
		item = item || (this.state.selected_rock_uri && ZProps.get( this.state.selected_rock_uri));
		if (item) {
			ZProps.set("clipboard", item);
		}
	}
	clipboardPaste = (target, where) => {
		target = target || (this.state.selected_rock_uri && ZProps.get( this.state.selected_rock_uri));
		if (target) {
			let item = ZProps.get("clipboard");
			if (item) {
				// TODO if compatible
				let new_uri;
				item.uri = "clipboard";
				if (where === undefined) {
					new_uri = this.props.graphman.replacePart(target.uri, item.uri);
				} else {
					new_uri = this.props.graphman.insertNewPart(target.uri, item.uri, where === "before");
				}
				this.props.graphman.rebuild();
				this.onRockSelect(new_uri, true);
			}
		}
	}
	onUndo = () => {
		if (this.props.transman.undo()) {
			this.forceUpdate();
		}
	}
	onRedo = () => {
		if (this.props.transman.redo()) {
			this.forceUpdate();
		}
	}
	onRockOpen(uri, flag) {
		let opened = this.state.opened;
		opened[uri] = flag === true || !opened[uri];
		this.setState({ opened: opened });
		this._updateCandies({ opened: opened });
	}
	onExpandAll() {
		this.onToggleExpandedRocks(true);
	}
	onCompressAll() {
		this.onToggleExpandedRocks(false);
	}
	onToggleExpandedRocks(flag) {
		// let EXPANDABLE_KINDS = ["service", "model", "pipeline", "algorithm"];
		let { service } = this.props;
		let opened = {};
		let nodes = AMC.getFlattenedService(service);
		nodes.forEach(n => {
			//if (EXPANDABLE_KINDS.indexOf(n.kind) !== -1) {
			if (n.nodes) {
				opened[n.uri] = flag;
			}
		});
		opened[service.uri] = flag;
		this.setState({ opened: opened });
		this._updateCandies({ opened: opened });
	}
	onClone() {
		let { service } = this.props;
		AMC.clone(service.uri, function(err, new_uri) {
			if (!err) {
				ROUTER.pushRoute("/zoo/" + new_uri);
			}
		});
	}
	assignTypeToRock = (item, desired_type) => {
		let { service } = this.props;
		let nodes = AMC.getFlattenedService(service);
		let node = nodes.find( n => n.uri = item.uri );
		node.type = desired_type.uri;
		ZProps.set(desired_type.uri, desired_type);
		ZProps.set(item.uri, node);
		AMC.save(service, (err) => {
		})
	}
	assignPropsToRock = (item) => {
	}
	updateRockIOPortPositions = (list) => {
		this.props.updateRockIOPortPositions(list);
	}
	onBackgroundContextMenu = (e) => {
		let { transman } = this.props;
		if (e.preventDefault) {
			e.preventDefault();
			e.stopPropagation();
		}
		let navrect = { top: 0, left: 0 };
		let item = this.state.selected_rock_uri && ZProps.get(this.state.selected_rock_uri);
		let contextmenu = { x: e.clientX - navrect.left, y: e.clientY - navrect.top, item: item, deletable: item && this.isDeleteable(item.uri) };
		let contextmenupopup = item ?
			<RockItemContextMenu context={contextmenu} ed={this} closeContextMenu={this.closeContextMenu.bind(this)} />
			:
			<RockBackgroundContextMenu context={contextmenu} ed={this} closeContextMenu={this.closeContextMenu.bind(this)} transman={transman} service={this.props.service} />;
		APP.showPopup(contextmenupopup, "transparent");
	}
	onContextMenu = (item, e) => {
		e.preventDefault();
		e.stopPropagation();
		let navrect = { top: 0, left: 0 };
		let contextmenu = { x: e.clientX - navrect.left, y: e.clientY - navrect.top, item: item, deletable: this.isDeleteable(item.uri) };
		let contextmenupopup = <RockItemContextMenu context={contextmenu} ed={this} closeContextMenu={this.closeContextMenu.bind(this)} />
		APP.showPopup(contextmenupopup, "transparent");
		this.onRockSelect(item.uri, true, true);
	}
	closeContextMenu() {
		APP.closePopups(null);
		// this.setState({ contextmenu: null });
	}
	onOperation = (op) => {
		if (op === "logs") {
			this.setState({ selected_rock_uri: null, selected_panel: "logs", inspector_open: true });
			this._updateCandies({ inspector_open: true, selected_panel: "logs" });
		} else if (op === "clearlog") {
			let { service } = this.props;
			ZAPI.invoke(op, service.uri, {}, (err, result) => {});
			service.error = null;
			AMC.update(service.uri, { error: null });
			this.forceUpdate();
		} else if (op === "inspect") {
			this.showInspector("notebook", true);
		} else if (op === "clone") {
			this.onClone();
		} else if (op === "upgrade") {
			ROUTER.pushRoute("/-/pricing");
		} else if (op === "fork") {
			let { service } = this.props;
			AMC.fork(service, (err, versioned_uri) => {
				ROUTER.pushRoute("/zoo/" + versioned_uri);
			});
		} else {
			this.props.onOperation(op);
		}
	}
	onSaved = () => {
		this.props.onOperation("saved");
	}
	collectValidationErrorsFromLogFile = (callback) => {
		let { service } = this.props;
		ZAPI.getLogs(service, false, (err, list) => {
			let errors_by_uri = {};
			if (Array.isArray(list)) {
				list.forEach( log => { if (log.level === "error" && log.uri) { errors_by_uri[log.uri] = { panel: "logs", msg: log.message } } } );
			}
			this.setState({ log_errors_by_uri: errors_by_uri });
			if (callback) {
				callback(null, errors_by_uri);
			}
		});
	}
	collectValidationErrors = (log_errors_by_uri) => {
		let { service } = this.props;
		let validation_errors = RockSanityCheck.validate(service);
		log_errors_by_uri = log_errors_by_uri || this.state.log_errors_by_uri || {};
		let errors_by_uri = Object.assign({}, log_errors_by_uri);
		(validation_errors || []).forEach( e => { errors_by_uri[e.uri] ? errors_by_uri[e.uri].msg += ", " + e.message : errors_by_uri[e.uri] = { panel: "properties", msg: e.message } });
		ZLog.debug("collectValidationErrors errors_by_uri=", { errors_by_uri: errors_by_uri });
		this.setState({ errors_by_uri: errors_by_uri });
	}
	handleButtonPress = (event) => {
		this.button_press_at = { clientX: event.clientX, clientY: event.clientY, timestamp: Date.now() };
	}
	handleButtonRelease = (e) => {
		let HYSTERESIS = 10;
		if (this.button_press_at && Math.abs(e.clientX - this.button_press_at.clientX) < HYSTERESIS && Math.abs(e.clientY - this.button_press_at.clientY) < HYSTERESIS && Date.now() - this.button_press_at.timestamp > 500) {
			this.onBackgroundContextMenu(e);
		}
	}
	onWorkspaceItemSelect = (item) => {
		this.setService(item);
	}
	render() {
		let { service, nav_open, workspace_open, transman, player, starting_new_runtime, onMethod } = this.props;
		let { opened, selected_rock_uri, inspector_open, nav_width, selected_panel, errors_by_uri } = this.state;
ZLog.debug("RockstarEditor transman=" + transman);
ZLog.debug("RockstarEditor inspector_open=" + inspector_open);
ZLog.debug("RockstarEditor selected_panel=" + selected_panel);


		// panes
		this.panes = [ { left: 0, right: 25 }, { left: 25, right: 50 }, { left:50, right: 100 } ];
ZLog.debug("panes=", {panes: this.panes});
ZLog.debug("nav_open=", {nav_open: nav_open, nav_width: nav_width, workspace_open: workspace_open });
ZLog.debug("panes=", {inspector_open: inspector_open});
		let workspace;
		if (workspace_open) {
			workspace = <RockWorkspace onWorkspaceItemSelect={this.onWorkspaceItemSelect} toggleInspector={() => this.showInspector(undefined, true)} inspector_open={inspector_open} selected_item={service} />
			player = null;
			nav_open = false;
		}
		if (!nav_open) {
			this.panes[1].left = 0;
		} else {
			nav_width = Math.max(25, nav_width);
		}
		if (!inspector_open) {
			this.panes[1].right = this.panes[2].right;
		}
			
ZLog.debug("now panes=", {panes: this.panes});
			
		
		nav_width = Math.min(nav_width, this.MAX_NAV_WIDTH);
		if (!nav_open) {
			nav_width = 0;
		}
		this.panes[0].right = nav_width;
		this.panes[1].left = nav_width;
ZLog.debug("final panes=", {panes: this.panes});
ZLog.debug("selected_rock_uri:" , selected_rock_uri + "inspector_open=" + inspector_open);
		// when player open and rockstar is open, inspector is open as the only part of rockstar visible then
		inspector_open = inspector_open || player;
		return (
			<div className="RockstarEditor" onClick={this.deselectAll} id="rockstar-editor-container">
				<div id="rockstar-rockpile" style={{width: this.panes[0].right + "%"}} >
					{ nav_open ? <RockpileWithIndex service={service} rs={this} />  : '' }
				</div>
				{ player || workspace || 
				<div id="rockstar-editor"  className={"RockstarEditorPanel " + AMCConstants.RESIZABLE_PANEL_CLASSNAME} data-dependent-resizable-panel-id="rockstar-rockpile" onContextMenu={this.onBackgroundContextMenu} style={{left: this.panes[1].left + "%", width: (this.panes[1].right - this.panes[1].left) + "%"}} data-hint="editor" 
					onTouchStart={this.handleButtonPress} 
					onTouchEnd={this.handleButtonRelease} 
					onMouseDown={this.handleButtonPress} 
					onMouseUp={this.handleButtonRelease} 
					onMouseLeave={this.handleButtonRelease}>
					<div className="RockstarEditorPanelScroller">
						<Rock node={service} opened={opened || {}} ed={this} service={service} errors_by_uri={errors_by_uri} />
					</div>
					<RockstarToDoList service={service} onMethod={onMethod} onOperation={this.onOperation} starting_new_runtime={starting_new_runtime} />
				</div>
				}
				{ inspector_open ?
				<div id="rockstar-inspector" className={"RockstarInspectorPanel " + AMCConstants.RESIZABLE_PANEL_CLASSNAME} data-dependent-resizable-panel-id={player ? "rockstar-player" : "rockstar-editor"} style={{left: this.panes[2].left + "%", right: 0 + "%"}} >
					<RockPanel key={selected_rock_uri + "-" + selected_panel + AMC.hashCode(selected_rock_uri ? ZProps.get(selected_rock_uri) : service)} ed={this} is_workspace={workspace_open} target_uri={selected_rock_uri || service.uri} selected_panel={selected_panel} service={service} transman={transman} onSelectPanel={this.onSelectPanel} onClosePanel={this.onCloseInspector} onRockSelect={this.onRockSelect} assignPropsToRock={this.assignPropsToRock} assignTypeToRock={this.assignTypeToRock} /> : null }
				</div>
				: '' }
			</div>
		);
	}
}
class RockstarToDoList extends React.Component {
	constructor(props) {
		super(props);
		let { service } = this.props;
		this.state = { model: AMC.getModel(service) };
	}
	componentDidMount() {
		let { service } = this.props;
		this.service_state_subscription = ZAPI.subscribe(service.uri + "/feed", (topic, payload) => {
			if (payload.name === "progress") {
				if (payload.finished) {
					this.setState({ progress: 100, progressing: null });
				} else {
					this.setState({ progress: payload.progress, progressing: payload.purpose });
				}
			}
		});
		this.listener = ZProps.addListener("service:changed:" + service.uri, (name, value, oldvalue) => {
			this.diff(true);
		});
		if (AMC.isEditable(service)) {
			this.diff();
		}
	}
	componentWillUnmount() {
		if (this.service_state_subscription) {
			ZAPI.unsubscribe(this.service_state_subscription);
		}
		if (this.listener) {
			ZProps.removeListener(this.listener);
		}
	}
	updateServiceCompute = (id) => {
		this.props.onMethod("speed", { id });
		this.setState({ popup: null });
	}
	diff = (force) => {
		let { service } = this.props;
		//ZAPI.isOutOfDate(service, force, (err, outofdate) => {
		AMC.isOutOfDate(service, force, (err, outofdate) => {
			this.setState({ outofdate: outofdate });
		});
	}
	render() {
		let { service, onOperation, starting_new_runtime } = this.props;
		let { popup, model, progress, progressing, outofdate } = this.state;
		let top = "train";
		let state = "untrained";
		let progressed = null;
		let working = null;
		let list = [];
		let group = ZProps.get("usergroup");
		let nodes = AMC.getFlattenedService(service);
		let test_pipeline = nodes.find( n => n.kind === "pipeline" && n.purpose === "test" );
		let train_pipeline = nodes.find( n => n.kind === "pipeline" && n.purpose === "train" );

		onOperation = (op) => {
			if (op === "speed") {
				this.setState({ popup: "speed" });
			} else {
				this.props.onOperation(op);
			}
		}
		if (popup === "speed") {
			popup = 
				<div className="RockstarToDoListPopup">
					<div className="RockstarToDoListPopupClose" onClick={ e => { e.preventDefault(); e.stopPropagation();this.setState({ popup: null }); } }><FontAwesomeIcon icon={faTimes} /></div>
					<RockContextMenuItem key="default" onClick={e => { e.preventDefault(); e.stopPropagation(); this.updateServiceCompute() } } icon={<FontAwesomeIcon icon={faAsterisk} />} label={"Use account default"} title={"Use compute as set as default by your account (displayed in bottom bar of editor)" } />
					{ AMCConstants.SPEEDS.map( s => {
						return <RockContextMenuItem key={s.name} onClick={e => { e.preventDefault(); e.stopPropagation(); this.updateServiceCompute(s.id) } } icon={<FontAwesomeIcon icon={faBolt} />} label={s.id + ". " + s.name} title={s.desc} />
					}) }
				</div>
		}
		AMC.assignDefaultPropertyValues(model);
		if (service.deployed) {
			top = { label: "Test demo app", op: "player", icon: faPlay };
			list = [
				{ label: "Retrain model", op: "retrain", icon: faRedoAlt, ignore: !train_pipeline },
				{ label: "Retest model", op: "retest", icon: faRedoAlt, ignore: !test_pipeline || outofdate },
				{ label: "Redeploy service", op: "redeploy", icon: faRedoAlt, ignore: outofdate && (train_pipeline || test_pipeline) },
				{ label: "Publish model", op: "publishmodel", icon: faShareSquare, ignore: !train_pipeline || model.published },
				{ label: "Republish model", op: "publishmodel", icon: faRedoAlt, ignore: !train_pipeline || !model.published },
				{ label: "Test API", op: "api", icon: faPlay },
				{ label: "Stop service", op: "stop", icon: faBan, red: true },
			];
			state = "deployed";
			working = <FontAwesomeIcon icon={faCheck} />
		} else if (service.state === "deploying") {
			top = { label: "Stop deploying", op: "stop", icon: faBan, red: true };
			list = [
				{ label: "Test demo app", op: "player", icon: faPlay, disabled: true },
				{ label: "Retrain model", op: "retrain", icon: faRedoAlt, ignore: !train_pipeline, disabled: true },
				{ label: "Retest model", op: "retest", icon: faRedoAlt, ignore: !test_pipeline || outofdate, disabled: true },
				{ label: "Redeploy service", op: "redeploy", icon: faRedoAlt, ignore: outofdate && (train_pipeline || test_pipeline), disabled: true },
				{ label: "Publish model", op: "publishmodel", icon: faShareSquare, ignore: !train_pipeline || model.published, disabled: true },
				{ label: "Republish model", op: "publishmodel", icon: faRedoAlt, ignore: !train_pipeline || !model.published, disabled: true },
				{ label: "Test API", op: "api", icon: faPlay, disabled: true },
			];
			state = "deploying";
		} else if (service.state === "training") {
			top = { label: "Stop training", op: "stop", icon: faBan, red: true };
			list = [
				{ label: "Test model", op: "test", icon: faPlay, disabled: true },
				{ label: "Deploy service", op: "deploy", icon: faPlay, disabled: true },
				{ label: "Test demo app", op: "player", icon: faPlay, disabled: true },
				{ label: "Test API", op: "api", icon: faPlay, disabled: true },
//				{ label: "Stop service", op: "stop", icon: faBan, disabled: true }
			];
			state = "training";
			outofdate = null;
			working = <img alt="working" src="/images/wait.gif" />
			progressed = progressing === "train" ? parseInt(progress * 100, 10) + "%" : null
		} else if (service.state === "testing") {
			top = { label: "Stop testing", op: "stop", icon: faBan, red: true };
			list = [
				{ label: "Retrain model", op: "retrain", icon: faRedoAlt, disabled: true },
				{ label: "Deploy service", op: "deploy", icon: faPlay, disabled: true },
				{ label: "Test demo app", op: "player", icon: faPlay, disabled: true },
				{ label: "Test API", op: "api", icon: faPlay, disabled: true },
//				{ label: "Stop service", op: "stop", icon: faBan, disabled: true }
			];
			state = "testing";
			outofdate = null;
			working = <img alt="working" src="/images/wait.gif" />
			progressed = progressing === "test" ? parseInt(progress * 100, 10) + "%" : null
//		} else if (model.tested) {
		} else if (service.tested) {
			top = { label: "Deploy service", op: "deploy", icon: faPlay };
			list = [
				{ label: "Retrain model", op: "retrain", icon: faRedoAlt, ignore: !train_pipeline },
				{ label: "Retest model", op: "retest", icon: faRedoAlt, ignore: !test_pipeline || outofdate },
				{ label: "Test demo app", op: "player", icon: faPlay, disabled: true },
				{ label: "Test API", op: "api", icon: faPlay, disabled: true },
//				{ label: "Stop service", op: "stop", icon: faBan, disabled: true }
			];
			state = "tested";
			working = <FontAwesomeIcon icon={faCheck} />
//		} else if (model.trained) {
		} else if (service.trained) {
			top = test_pipeline ? { label: "Test model", op: "test", icon: faPlay }
				: { label: "Deploy service", op: "deploy", icon: faPlay };
			list = [
				{ label: "Retrain model", op: "retrain", icon: faRedoAlt, ignore: !train_pipeline },
				{ label: "Deploy service", op: "deploy", icon: faPlay },
				{ label: "Publish model", op: "publishmodel", icon: faShareSquare, ignore: !train_pipeline || model.published },
				{ label: "Republish model", op: "publishmodel", icon: faRedoAlt, ignore: !train_pipeline || !model.published },
				{ label: "Test demo app", op: "player", icon: faPlay, disabled: true },
				{ label: "Test API", op: "api", icon: faPlay, disabled: true },
//				{ label: "Stop service", op: "stop", icon: faBan, disabled: true }
			];
			state = "trained";
			working = <FontAwesomeIcon icon={faCheck} />
		} else {
			top = { label: "Train model", op: "train", icon: faPlay };
			list = [
				{ label: "Test model", op: "test", icon: faPlay, disabled: true },
				{ label: "Deploy service", op: "deploy", icon: faPlay, disabled: true },
				{ label: "Test demo app", op: "player", icon: faPlay, disabled: true },
				{ label: "Test API", op: "api", icon: faPlay, disabled: true },
//				{ label: "Stop service", op: "stop", icon: faBan, disabled: true }
			];
			state = "untrained";
			outofdate = null;
		}
		//if (!test_pipeline) {
//			top = top.filter( op => op.indexOf("test") === -1 );
		//}
		if (!top) {
			top = list.shift();
		}
		top.is_top = true;
		list.unshift(top);
		if (service.state === "error") { //  || model.state === "error") {
			list.unshift({ label: "View errors", op: "logs", icon: faTerminal, red: true });
		}
		list.push({ label: "Clear log/errors", op: "clearlog", icon: faTimes });
		if (!AMC.isEditable(service)) {
			list = [{ label: "Clone", op: "clone", icon: faClone, disabled: false, is_top: true }];
		} else {
			list.push({ label: "Clone", op: "clone", icon: faClone, disabled: false });
		}
		if (AMC.isEditable(service)) {
			list.push({ label: "Fork v." + ((service.last_version || 0) + 1) , op: "fork", icon: faCodeBranch });
		}
		if (AMC.isEditable(service)) {
			list.splice(1, 0, { label: (service.compute ? "Compute (" + service.compute + ")" : "Compute (*)"), op: "speed", icon: faBolt, title: service.compute ? null : "Using your account's default Compute" });
		}
		list.push({ label: "Inspect...", op: "inspect", icon: faList });

		list = ZUtil.uniqBy(list, "label", true);
		let capacity = AMC.getCapacity(group);
		if (capacity <= 0) {
//			list.unshift({ label: "Capacity " +  ZUtil.decimalPlaces(capacity || 0, 2), op: "upgrade", icon: faExclamationTriangle, red: true });
			list.unshift({ label: "Out of compute", op: "upgrade", icon: faExclamationTriangle, red: true, title: "Click to upgrade membership or add battery pack" });
		}
		outofdate = outofdate && (train_pipeline || test_pipeline || state === "deployed");
		if (outofdate) {
			outofdate = <span className="RockstarToDoListOutOfDate" title={"Out of date. Changes since " + state}><FontAwesomeIcon icon={faClock} /></span>
		}
		if (starting_new_runtime) {
			if (starting_new_runtime.startsWith("stop")) {
				state = "Stopping";
			} else {
				state = "Launching";
			}
		}
		let production_errors = null;
		if (service.state === "deployed" && service.errors) {
			production_errors = <span className="RockstarToDoListProductionErrors" title="Production errors"><FontAwesomeIcon icon={faClock} /> ({service.errors})</span>
		}
		return (
			<div className="RockstarToDoList" data-hint="todo list">
				<div className="RockstarToDoListState">
					{working} {outofdate} {state} {progressed} {production_errors}
				</div>
				{ service.stats && (service.stats.accuracy || service.stats.RMSE) ?
					<div className="RockstarToDoListAccuracy">Accuracy: <strong>{ZUtil.toShortNumber(service.stats.accuracy ? service.stats.accuracy * 100 : service.stats.RMSE, 4)}% </strong></div>
				: '' }
				<div className="RockstarToDoListContents">
					{ list.map( (op, index) => {
						let className = op.red ? "RockstarToDoListRed" : op.is_top ? "RockstarToDoListGreen" : "";
						return op.ignore ? '' : <RockContextMenuItem key={op.label} className={className} disabled={op.disabled} onClick={e => { e.preventDefault(); e.stopPropagation(); onOperation(op.op) } } icon={<FontAwesomeIcon icon={op.icon} />} label={op.label} keystroke={op.keystroke} title={op.title} /> 
					} ) }
					{ popup }
				</div>
			</div>
		);
	}
}
export class Rock extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	render() {
		let { node, y, indent, opened, service, ed, container, errors_by_uri } = this.props;
		errors_by_uri = errors_by_uri || {};
		y = y || 0;
		indent = indent || 0;
			

		let lego = [];

		let thumb = AMC.getNodeThumb(node);
		thumb = typeof thumb === "string" ? <img src={thumb} alt={node.title} /> : thumb;
		let component = node.type ? ZProps.get(node.type) : null;
		let ownerthumb = node.group ? AMC.getUserOrGroupThumbElement(node.group) : component ? AMC.getUserOrGroupThumbElement(component.group) : null;
		ownerthumb = null;
		let me = ZProps.get("user");
		let options = { hoverdetails: true };
		let io_port_positions = ZProps.get("rock_io_port_positions");
		if (node.nodes) {
				let kind = node.kind;
				let name = kind === "pipeline" ? node.purpose + " pipeline" : node.name;
				let purpose = node.purpose;
				let purposed = container && container[purpose + "ed"];
				let purposing = container && container.state === (purpose + "ing");
				let op = purposing ? "stop" : purpose === "production" ? "deploy" : purpose;
				let playbutton = null;
				let inputs = node.inputs || (ROCK_IO_PORT_GENERICS[node.kind] && ROCK_IO_PORT_GENERICS[node.kind].inputs) || [];
				let outputs = node.outputs || (ROCK_IO_PORT_GENERICS[node.kind] && ROCK_IO_PORT_GENERICS[node.kind].outputs) || [];
				let max_io_port_position = inputs.concat(outputs).reduce((total, port) => Math.max(total, io_port_positions[port.split(":")[0]]), 0);
				let hint;
				if (node.kind === "pipeline") {
					let purpose = node.purpose;
					hint = purpose + " pipeline";
					let checked = purposed || service.deployed;
					kind = purpose + (purpose === "production" ? "" : "ing ") + node.kind;
					playbutton = <div 
						onClick={e => { if (!node.group || me.group === node.group) { e.stopPropagation(); ed.onOperation(op) }}}>
						{ purpose === "production" ?
							<span className="RockPlayButton">
								<span className="RockPlayButtonToggle"><FontAwesomeIcon icon={service.deployed ? faBan : faPlay} /></span>
								<span className="RockPlayButtonRedo ZToolTip ZToolTipTop" data-tooltip={service.deployed ? "stop service" : "deploy service"}><FontAwesomeIcon icon={service.deployed ? faBan : faPlay} /></span>
							</span>
						:
							<span className="RockPlayButton">
								<span className={"RockPlayButtonToggle" + (checked ? " RockPlayButtonDone" : "")}><FontAwesomeIcon icon={checked ? faCheck : purposing ? faBan : faPlay} /></span>
								<span className="RockPlayButtonRedo ZToolTip ZToolTipTop" data-tooltip={purposed ? "rerun " + purpose + "ing pipeline" : purposing ? "stop " + purpose + "ing" : "run " + purpose + "ing pipeline"}><FontAwesomeIcon icon={purposed ? faRedoAlt : purposing ? faBan : faPlay} /></span>
							</span>
						}
					</div>
				} else {
					hint = node.kind;
				}

				lego = <div className={"Rock RockContainer Rock" + node.kind + " RockIndentation" + indent + (ZProps.get("selected_rock_uri") === node.uri ? " RockContainerSelected" : "") + (" RockMinWidth" + max_io_port_position)} onClick={e => { e.stopPropagation(); ed.onRockSelect(node.uri) }} onContextMenu={e => ed.onContextMenu(node, e)} >
					<div className={"RockTop RockTop" + node.kind + " ClearFix" + (options.hoverdetails ? " RockHoverableDetails" : "")} style={ROCK_STYLES[node.kind]} data-hint={hint} data-uri={node.uri}>
						{ thumb }
						{ playbutton || ownerthumb } 
						<div className={"RockContent RockContainerContent" + (node.kind === "service" ? " RockContainerContentService" : "")}>
							<div className="RockKind">{name}</div>
							<div className="RockName">{node.name}</div>
							<div className="RockComponentName">{node.type}</div>
						{ outputs.map( output => {
							let [name, type] = output.split(":");
							return <RockOutput key={name} name={name} title={output} position={io_port_positions[name]} shape={ROCK_IO_PORT_SHAPES[type.trim()]} style={ROCK_STYLES[node.kind]} />
						}) }
						</div>
						{ service.error && (node.kind === "service" || (purpose && service.error.pipeline === purpose)) ? 
							<div className="RockletError" title={service.error.msg || "Some components are reporting errors"}><FontAwesomeIcon icon={faExclamationTriangle} onClick={e => ed.showInspector("logs")} /></div>
						: '' }
						{ errors_by_uri[service.uri] && node.kind === "service" ?
							<div className="RockletError" title={errors_by_uri[service.uri].msg}><FontAwesomeIcon icon={faExclamationTriangle} /></div>
						: '' }
					</div>
					<div className="RockBody">
						<div className="RockBodyTouchable" style={ROCK_STYLES[node.kind]}>
						</div>
						{ !opened || opened[node.uri] ? node.nodes.map( n => <Rock node={n} key={n.uri} y={y} indent={indent + 1} opened={opened} ed={ed} service={service} container={node} errors_by_uri={errors_by_uri} /> ) : ''}
					</div>
					<div className="RockBottom" style={ROCK_STYLES[node.kind]} onClick={ e => { e.stopPropagation(); ed.onRockOpen(node.uri) } }>
						{ opened ? <FontAwesomeIcon icon={opened[node.uri] ? faChevronUp : faChevronDown} /> : '' }
					</div>
				</div>
		} else {
			if (node.uri === ZProps.get("drop_target_placeholder_uri")) {
				// first insert the placeholder
				let loc = ZProps.get("drop_target_placeholder_uri_location");
				ZLog.debug("render: drop target=" + ZProps.get("drop_target_placeholder_uri"));
				ZLog.debug("render: drop target=" + node.type);
				ZLog.debug("render: drop target loc=" + loc);
				return	(
					<div>
						{ loc === "before" || loc === "replace" ? <div><Rocklet placeholder={true} indent={indent} ed={ed} /></div> : '' }
						{ loc !== "replace" ? <div><Rocklet node={node} indent={indent} options={options} ed={ed} /></div> : '' }
						{ loc === "after" ? <div><Rocklet placeholder={true} indent={indent} ed={ed} /></div> : '' }
					</div>
				)
			}
			if (node.uri === ZProps.get("drop_source_placeholder_uri")) {
				// just show the placeholder
				options.className = "RockDNDSourcePlaceholder";
			}
			options.className = (options.className || "") + (node.kind !== "algorithm" ? " DragAndDropMovable" : "");
			ZLog.debug("About to render: " + node.uri, { errors_by_uri: errors_by_uri }); // service.error
			lego = <Rocklet node={node} service={service} indent={indent} options={options} ed={ed} error={errors_by_uri[node.uri]} />
		}
		return <div>{lego}</div>;
	}
}
class RockInput extends React.Component {
	render() {
		let { name, position, style, shape } = this.props;
		shape = shape || "Notch";
		return (
			<div className={"RockInput RockPortPosition" + position}>
				<div className={"RockInput" + shape} style={style}></div>
				<div className="RockInputName">{name}</div>
			</div>
		)
	}
}
class RockOutput extends React.Component {
	render() {
		let { name, position, style, shape, title } = this.props;
		shape = shape || "Notch";
		return (
			<div className={"RockOutput RockPortPosition" + position} title={title}>
				<div className={"RockOutput" + shape} style={style}></div>
				<div className="RockOutputName">{name}</div>
			</div>
		)
	}
}
export class RockpileWithIndex extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	componentDidMount() {
//		ZNetwork.post("things", { kinds: ROCK_PILE_INDEX.reduce((kinds, i) => kinds = kinds.concat(i.kinds), [] ), ttl: 5*60*1000 }, (err, bests) => {
		let rockpile = AMC.getSetting("rockpile");
		if (!rockpile) {
			return setTimeout( this.componentDidMount.bind(this), 50);
		}
		let uris = rockpile.list.reduce( (uris, section) => uris = uris.concat(section.uris), [] );
		ZNetwork.post("things", { uris: uris, ttl: 5*60*1000 }, (err, bests) => {
			if (err) {
				APP.setError("Unable to fully load Rockpile");
				bests = [];
			}
			let content = [];
			for (let i = 0; i < bests.length; ++i) {
				if (!bests[i]) {
					ZLog.warn("Rockpile contains component that no longer exists: " + uris[i]);
				}
			}
			bests = bests.filter( b => !!b );
			let missing_types = ZUtil.uniq(bests.filter( b => b.type && !ZProps.get(b.type) ).map( t => t.type ));
			ZNetwork.post("things", { uris: missing_types, ttl: 5*60*1000 }, (err, best_types) => {
				if (err) {
					APP.setError("Unable to fully load Rockpile types");
					best_types = [];
				}

missing_types.forEach( (s, index) => {
	if (!best_types[index]) {
ZLog.error("rockpile no type for: " + missing_types[index]);
	} else {
ZLog.debug("rockpile downloaded required type: " +  missing_types[index]);
}
});

				// datasets, modelsets and ui have no spec
				bests.forEach( b => ZProps.set(b.uri, b) );
				best_types.forEach( t => { if (t) { ZProps.set(t.uri, t) } } );
				for (let i = 0; i < rockpile.list.length; ++i) {
					let label = rockpile.list[i].label;
					let uris = rockpile.list[i].uris;
					let list = bests.filter( n => uris.indexOf(n.uri) !== -1 ).map( n => { return { kind: n.kind, name: n.name || n.uri.split("/")[2], uri: n.uri, type: n.type || n.uri } } );
					if (list.length === 0) {
						ZLog.warn("No rocks found for label: " + label);
					} else {
						list = ZUtil.uniqBy(list, "uri");
						list.unshift({ label: label, display: rockpile.list[i].display })
					}
					content = content.concat(list);
				}
				this.setState({ content: content });
			});
		});
	}
	scrollRockPileTo = (label) => {
		this.setState({ scroll_to: label });
	}
	render() {
		let { rs, service } = this.props;
		let { scroll_to, content } = this.state;
		let rockpile = AMC.getSetting("rockpile");
		if (!rockpile) {
			return <PleaseStandBy />
		}
		return  (
			<div className="RockpileWithIndex">
				<div className="RockpileIndex">
					{ rockpile.list.map( section => {
						let twolines = section.display && section.display.indexOf(" ") !== -1;
						return <div className="RockpileIndexButton" key={section.label} onClick={e => this.scrollRockPileTo(section.label)}><div className="RockpileIndexDot" style={{background: ROCK_PILE_INDEX_STYLES[section.label].background}}></div><div className={"RockpileIndexLabel" + (twolines ? " RockpileIndexLabelTwoLines" : "")} style={{color: section.label === "generic" ? "#444" : ROCK_PILE_INDEX_STYLES[section.label].background}}>{twolines ? <span>{section.display.split(" ")[0]}<br/>{section.display.split(" ")[1]}</span> : (section.display || section.label)}</div></div>
					} ) }
				</div>
				<Rockpile service={service} rs={rs} content={content} scrolled_to={scroll_to} />
			</div>
		);
	}
}
export class Rockpile extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.interactors = [];
	}
	componentDidMount() {
		this.props.rs.updateRockIOPortPositions(Object.keys(ROCK_IO_PORT_GENERICS).map( kind => ROCK_IO_PORT_GENERICS[kind] ));
		this.interactors.push(
			new DragAndDropMove(document.body, "DragAndDroppable", (e, x, y) => {
				// ----------
				// PICKUP
				// ----------
				ZProps.set("drop_source_placeholder_uri", e.getAttribute("data-uri"));
				ZProps.set("drop_source_placeholder_rect", null);
			}, (e, x, y) => {
				// ----------
				// DRAG
				// ----------
				this.props.rs.showDropTarget(e.getAttribute("data-uri"), x, y);
			}, (e, x, y, cb) => {
				// ----------
				// DROP
				// ----------
				if (!this.props.rs.insertDroppable(e, x, y)) {
					// ----------
					// scurry home
					// ----------
					return this.props.rs.scurryHome(e, cb);
				}
				return cb();
			}, (e) => {
				return !APP.isPopped();
			}).enable()
		);
		this.componentDidUpdate();
	}
	componentWillUnmount() {
		for (var i = 0; i < this.interactors.length; ++i) {
			this.interactors[i].disable();
		}
	}
	render() {
		let { content } = this.props;
		if (this.last_scrolled_to !== this.props.scrolled_to) {
			this.scroll_to = this.props.scrolled_to;
		}
		
		content = content || [];
		return  (
			<div className="Rockpile" id="rockpile" data-hint="the rockpile" >
				{ content.map( r => {
					r.uri = r.label || r.uri || (r.kind + r.name);
					return (
						<div key={r.uri}>
						{ r.label ? 
							<div id={"RockpileLabel" + r.label}  className="RockpileLabel">{r.display || r.label}</div>
							:
							<Rocklet key={r.kind + r.uri} node={r} indent={0} options={{hoverdetails: false, className: "DragAndDroppable", pile: true}} /> 
						}
						</div>
					);
				} ) }
			</div>
		);
	}
	componentDidUpdate() {
		let { content } = this.props;
		if (content && this.scroll_to != null) {
			ZUtil.scrollToTop("RockpileLabel" + this.scroll_to, "rockpile", true);
			this.last_scrolled_to = this.scroll_to;
			this.scroll_to = null;
		}
	}
}
class Rocklet extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	onContextMenu = (e) => {
		e.preventDefault();
		if (this.props.onLineItemContextMenu) {
			this.props.onLineItemContextMenu(this.props.node, e);
		}
	}
	componentDidMount() {
		this.listener = ZProps.addListener("selected_rock_uri", (name, value, oldvalue) => {
			if (this.props.node && this.props.node.uri && (value === this.props.node.uri || oldvalue === this.props.node.uri)) {
				this.forceUpdate();
			}
		});
	}
	componentWillUnmount() {
		ZProps.removeListener(this.listener);
	}
	render() {
		let { node, indent, options, placeholder, ed, service, error } = this.props;
		if (placeholder) {
			let n = ZProps.gett("drop_source_placeholder_node");
			return <div className={"Rock RockDNDTargetPlaceholder RockIndentation" + indent} >{ n ? <Rocklet node={n} indent={indent} options={{className: "RockDNDTargetPlaceholderNode"}} ed={ed} /> : '' }</div>;
		}
		options = options || {};
		let thumb = AMC.getNodeThumb(node);
		thumb = typeof thumb === "string" ? <img src={thumb} alt={node.title} /> : thumb;
		let component = node.type ? ZProps.get(node.type) : null;
if (node.type && !component) {
ZLog.debug("Rocklet - No component found for node: " + node.uri + ", type:" + node.type);
}
		let ownerthumb = node.group ? AMC.getUserOrGroupThumbElement(node.group) : component ? AMC.getUserOrGroupThumbElement(component.group) : null;
ownerthumb = null;
		let io_port_positions = ZProps.get("rock_io_port_positions");
//		let rock_io_port_max_position = ZProps.get("rock_io_port_max_position");
		let inputs = node.inputs || (component && component.inputs) || (ROCK_IO_PORT_GENERICS[node.kind] && ROCK_IO_PORT_GENERICS[node.kind].inputs) || [];
		let outputs = node.outputs || (component && component.outputs) || (ROCK_IO_PORT_GENERICS[node.kind] && ROCK_IO_PORT_GENERICS[node.kind].outputs) || [];
//if (node.kind === "trainer") {
//ZLog.debug("trainer inputs:", { inputs: inputs, component: component, node: node });
//}
		if (node.kind === "dataset") {
			// TODO: dataset may refer to type that is not loaded / part of the rockpile, load it somehow
			if (ZProps.get(node.type)) {
				inputs = ZProps.get(node.type).inputs || [];
				outputs = ZProps.get(node.type).outputs || [];
			}
		}
		if (error) {
			ZLog.debug("Rocklet error message: ", { error: error });
		}
//ZLog.log("rocklet node=" + node.uri, { inputs: inputs, outputs: outputs, node: node, pile: options.pile, kind: kind });
		let max_io_port_position = inputs.concat(outputs).reduce((total, port) => Math.max(total, io_port_positions[port.split(":")[0]]), 0);
//console.log("max_io_port_position=" + node.kind + " => " + max_io_port_position);
		let kind = options.pile ? node.name || node.kind : node.name || node.type.split("/")[2]; // node.type.split("/")[2
		

//console.log("now Rocklet ownerthumb=" + ownerthumb);
//console.log("now Rocklet options.pile=" + options.pile);
//console.log("Rocklet node=" + node + ",service=" + service);
// { service && service.error && service.error.uri === node.uri ? 
		return ( 
			<div id={options.pile ? "Rocklet" + node.uri : "editor-" + node.uri} className={"Rock Rock" + node.kind + " RockIndentation" + indent + (options.className ? " " + options.className : "") + (!options.pile && node.uri && ZProps.get("selected_rock_uri") === node.uri ? " RockSelected" : "") + " RockMinWidth" + max_io_port_position} onClick={e => { e.stopPropagation(); if (ed) { ed.onRockSelect(node.uri) } }} data-uri={node.uri} data-kind={node.kind} onContextMenu={e => { if (ed) { ed.onContextMenu(node, e) }}} >
				<div className={"RockChicklet" + (options.hoverdetails ? " RockHoverableDetails" : "")} style={ROCK_STYLES[node.kind]}>
					<span className="RockletThumb">{ thumb }</span>
					<span className="RockletThumb">{ ownerthumb }</span>
					<div className="RockContent">
						<div className="RockKind">{kind}</div>
						<div className="RockName">{node.name}</div>
						<div className="RockComponentName">{node.type}</div>
						{ inputs.map( input => {
							let [name, type] = input.split(":");
							return <RockInput key={name} name={name} position={io_port_positions[name]} shape={ROCK_IO_PORT_SHAPES[type.trim()]} style={ROCK_STYLES[node.kind]} />
						}) }
						{ outputs.map( output => {
							let [name, type] = output.split(":");
							return <RockOutput key={name} name={name} title={output} position={io_port_positions[name]} shape={ROCK_IO_PORT_SHAPES[type.trim()]} style={ROCK_STYLES[node.kind]} />
						}) }
						{ node.kind === "viz" ? <RockletViz node={node} service={service} /> : '' }
						{ error ? 
							<div className={error.panel === "properties" ? "RockletPropertyError" : "RockletError"} title={error.msg} onClick={e => ed.showInspector(error.panel)}><FontAwesomeIcon icon={error.panel === "properties" ? faExclamationCircle : faExclamationTriangle} /></div>
						: '' }
					</div>
				</div>
			</div>
		);
	}
}
class RockletViz extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	componentDidMount() {
		let { service, node } = this.props;
		if (service) {
			// not in rockpile
			this.service_state_subscription = ZAPI.subscribe(service.uri + "/feed", (topic, payload) => {
				ZLog.debug("RockletViz received realtime feed: ", { nodeuri: node.uri, payloaduri: payload.uri, payload: payload });
				if (payload.name === "image" && payload.uri === node.uri) {
					//console.log("setting image");
					this.setState({ image: payload.image });
				}
			});
/*
			ZAPI.invoke("getHistory", service.uri, { topic: "image" }, (err, list) => {
				this.setState({ image: (list.find( item => item.uri === node.uri ) || {}).image });
			});
*/
		}
	}
	componentWillUnmount() {
		if (this.service_state_subscription) {
			ZAPI.unsubscribe(this.service_state_subscription);
		}
	}
	onError = () => {
		this.setState({ error: true });
	}
	render() {
		let { service, node } = this.props;
		let { error } = this.state;
		// ignore image, it points to raw s3 address, and just use it to refresh the image as it is grown in realtime
		return (
			<div className="RockletViz">
				<img alt="visualization" src={((error || !service) ? "/images/clear.gif" : ZUtil.getDataServer() + "/" + service.uri + "/" + node.uri)} onError={this.onError} />
			</div>
		)
	}
}
class DragAndDropMove {
	constructor(container_id, pickable_classname, pickupHandler, dragHandler, dropHandler, enablingHandler) {
		this.container_id = container_id;
		this.pickable_classname = pickable_classname;
		this.pickupHandler = pickupHandler;
		this.dragHandler = dragHandler;
		this.dropHandler = dropHandler;
		this.enablingHandler = enablingHandler;
		this.HYSTERESIS = 10;
	}
	container = () => {
		return typeof this.container_id === "string" ? document.getElementById(this.container_id) : this.container_id;
	}
	enable = () => {
		document.body.addEventListener('mousedown', this._onDown, false);
		document.body.addEventListener('touchstart', this._onDown, false);
		document.body.addEventListener('keyup', this._onKey, false);
		return this;
	}
	disable = () => {
		document.body.removeEventListener('mousedown', this._onDown);
		document.body.removeEventListener('touchstart', this._onDown);
		document.body.removeEventListener('keyup', this._onKey);
	}
	_onKey = (e) => {
		if (e.keyCode === 27 || e.key === "Escape") {
			if (this._element) {
				this.container().removeChild(this._element);
				this._element = null;
				this.dragging = false;
				document.removeEventListener('mousemove', this._onMove, false);
				document.removeEventListener('mouseup', this._onMouseUp, false);
				document.removeEventListener('touchmove', this._onMove);
				document.removeEventListener('touchend', this._onTouchEnd);
				e.preventDefault();
				e.stopPropagation();
			}
		}
	}
	_onDown = (e) => {
		if (e.button === 0 && this.enablingHandler(e)) {
//console.log("ondown DND " + this.pickable_classname);
			this._startPos = this._pos = ZUtil.getMousePositionXY(e, document.body);
			this._element = ZUtil.pick(this.pickable_classname, this._pos.x, this._pos.y);
			if (this._element) {
//console.log("PICKUP NODE");
				this.dragging = false;
				if (!e.touches) {
					document.addEventListener('mousemove', this._onMove, false);
					document.addEventListener('mouseup', this._onMouseUp, false);
				} else if (e.touches.length === 1) {
					document.addEventListener('touchmove', this._onMove, false);
					document.addEventListener('touchend', this._onTouchEnd, false);
				}
				e.preventDefault();
				e.stopPropagation();
			}
		}

	}
	_onMove = (e) => {
//console.log("onmove DND");
		if (!this._element) {
			return;
		}
		var pos = this._pos = ZUtil.getMousePositionXY(e, document.body);
		e.preventDefault();
		e.stopPropagation();
		var container = this.container();
		if (!this.dragging && this._element) {
			if (Math.abs(pos.x - this._startPos.x) > this.HYSTERESIS || Math.abs(pos.y - this._startPos.y) > this.HYSTERESIS) {
				this.dragging = true;
				this._element = this._element.cloneNode(true);
				this._element.className = this._element.className.replace(this.pickable_classname, "") + " RockDNDDroppable";
				//this._element.style.position = "absolute";
				container.appendChild(this._element);
				this.pickupHandler(this._element, pos.x, pos.y);
			} else {
				return;
			}
		}
//console.log("pos.x=" + pos.x + "," + pos.y);
		var rect = container.getBoundingClientRect();
		this._element.style.left = (pos.x - this._element.offsetWidth/2 - rect.left) + "px";
		this._element.style.top = (pos.y - this._element.offsetHeight/2 - rect.top) + "px";
		this._pos = pos;
		this.dragHandler(this._element, this._pos.x, this._pos.y);
	}
	_onUp = (e) => {
		if (this._element) {
//		this._element.style.cursor = 'default';
			e.preventDefault();
			e.stopPropagation();
			if (this.dragging) {
			//this._pos.x -= this._element.offsetWidth/2;
			//this._pos.y -= this._element.offsetHeight/2;
				this.dropHandler(this._element, this._pos.x, this._pos.y, () => {
					this.container().removeChild(this._element);
					this._element = null;
				});
			}
			this.dragging = false;
		}
	}
	_onMouseUp = (e) => {
		this._onUp(e);
		document.removeEventListener('mousemove', this._onMove, false);
		document.removeEventListener('mouseup', this._onMouseUp, false);
	}
	_onTouchEnd = (e) => {
		this._onUp(e);
		document.removeEventListener('touchmove', this._onMove);
		document.removeEventListener('touchend', this._onTouchEnd);
	}
	
};


class RockItemContextMenu extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
		let { context } = this.props;
		let item = context.item;
		let kind = item.kind;
		this.MENU_OPTIONS = [
			{ label: "cut", type: "cut", icon: <FontAwesomeIcon icon={faCut} />, keystroke: "Ctrl-X" },
			{ label: "copy", type: "copy", icon: <FontAwesomeIcon icon={faCopy} />, keystroke: "Ctrl-C" },
			{ label: "paste", type: "paste", icon: <FontAwesomeIcon icon={faPaste} />, keystroke: "Ctrl-V" },
		];
		if (kind === "service" || kind === "modelsource" || kind === "pipeline") {
			this.MENU_OPTIONS.push(
				{ label: "open/close", type: "toggleopen", icon: <FontAwesomeIcon icon={faFolderOpen} /> },
			);
		}
		if (kind !== "service") {
			this.MENU_OPTIONS = this.MENU_OPTIONS.concat([
				{ label: "open in new tab", type: "openinnewtab", icon: <FontAwesomeIcon icon={faExternalLinkAlt} /> },
			]);
		}
		if (context.deletable) {
			this.MENU_OPTIONS = this.MENU_OPTIONS.concat([
				{ label: "separator" },
				{ label: "delete", type: "delete", icon: <FontAwesomeIcon icon={faTrashAlt} />, keystroke: "del" },
			]);
		}
		this.MENU_OPTIONS = this.MENU_OPTIONS.concat([
			{ label: "separator" },
			{ label: "inspect", type: "inspect", icon: <FontAwesomeIcon icon={faList} /> },
		]);

	}
	onClick(type, e) {
		e.preventDefault();
		e.stopPropagation();
		let { context, ed } = this.props;
		ed.closeContextMenu();
		switch (type) {
			case "new" :
				ed.newPlaceholder(context.item);
				break;
			case "delete" :
				ed.onRockDelete(context.item.uri);
				break;
			case "cut" :
				ed.clipboardCopy(context.item);
				ed.onRockDelete(context.item.uri);
				break;
			case "copy" :
				ed.clipboardCopy(context.item);
				break;
			case "paste" :
				ed.clipboardPaste(context.item, "after");
				break;
			case "openinnewtab" :
				window.open("/zoo/" + (context.item.kind === "service" || context.item.kind === "modelsource" ? context.item.uri : context.item.type));
				break;
			case "inspect" :
				ed.showInspector();
				break;
			case "toggleopen" :
				ed.onRockOpen(context.item.uri);
				break;
			default:
				ZLog.error("RockItemContextMenu unknown option=" + type);
				break;
		}
	}
	render() {
		let { context } = this.props;
		let menuitems = this.MENU_OPTIONS.map( (x, index) => { 
			return <RockContextMenuItem key={x.label + index} disabled={x.type === "paste" && !ZProps.get("clipboard")} onClick={this.onClick.bind(this, x.type)} icon={x.icon} label={x.label} keystroke={x.keystroke} /> 
		})
		let style = { left: context.x + "px", top: context.y + "px" };
		return (
			<div className="RockContextMenu" style={style}>
				{menuitems}
			</div>
		)
	}
}

class RockBackgroundContextMenu extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
		let { service, transman } = this.props;
		let editable = AMC.isEditable(service);
//		let model = service.nodes.find(n => n.kind === "modelsource");
		this.MENU_OPTIONS = [
			{ label: "expand", type: "expand", icon: <FontAwesomeIcon icon={faExpandArrowsAlt} />, keystroke: "" },
			{ label: "compress", type: "compress", icon: <FontAwesomeIcon icon={faCompressArrowsAlt} />, keystroke: "" },
		];
		if (editable) {
			this.MENU_OPTIONS.push( { label: "separator" } );
			if (!service.trained) {
				this.MENU_OPTIONS.push(
					{ label: "train", type: "train", icon: <FontAwesomeIcon icon={faUserGraduate} />, keystroke: "" }
				);
			} else {
				if (!service.tested) {
					this.MENU_OPTIONS.push(
						{ label: "test", type: "test", icon: <FontAwesomeIcon icon={faCheck} />, keystroke: "" }
					);
				}
				this.MENU_OPTIONS.push(
					{ label: "deploy", type: "deploy", icon: <FontAwesomeIcon icon={faWifi} />, keystroke: "" }
				);
			}
		}
		this.MENU_OPTIONS = this.MENU_OPTIONS.concat([
			{ label: "separator" },
		]);
		if (transman.hasUndo()) {
			this.MENU_OPTIONS = this.MENU_OPTIONS.concat([
				{ label: "undo", type: "undo", icon: <FontAwesomeIcon icon={faUndoAlt} />, keystroke: "Ctrl-Z" },
			]);
		}
		if (transman.hasRedo()) {
			this.MENU_OPTIONS = this.MENU_OPTIONS.concat([
				{ label: "redo", type: "redo", icon: <FontAwesomeIcon icon={faRedoAlt} />, keystroke: "Ctrl-Y" },
			]);
		}
		this.MENU_OPTIONS = this.MENU_OPTIONS.concat([
			{ label: "clone", type: "clone", icon: <FontAwesomeIcon icon={faClone} /> },
		]);
		this.MENU_OPTIONS = this.MENU_OPTIONS.concat([
			{ label: "separator" },
			{ label: "inspect", type: "inspect", icon: <FontAwesomeIcon icon={faList} /> },
		]);

	}
	onClick(type, e) {
		e.preventDefault();
		e.stopPropagation();
		let { ed } = this.props;
		ed.closeContextMenu();
		switch (type) {
			case "expand" :
				ed.onExpandAll();
				break;
			case "compress" :
				ed.onCompressAll();
				break;
			case "train" :
				ed.onOperation("train");
				break;
			case "test" :
				ed.onOperation("test");
				break;
			case "deploy" :
				ed.onOperation("deploy");
				break;
			case "clone" :
				ed.onClone();
				break;
			case "undo" :
				ed.onUndo();
				break;
			case "redo" :
				ed.onRedo();
				break;
			case "inspect" :
				ed.showInspector();
				break;
			default:
				ZLog.error("RockBackgroundContextMenu unknown type=" + type);
				break;
		}
	}
	render() {
		let { context } = this.props;
		let menuitems = this.MENU_OPTIONS.map( (x, index) => { 
			return <RockContextMenuItem key={x.label + index} disabled={x.type === "paste" && !ZProps.get("clipboard")} onClick={this.onClick.bind(this, x.type)} icon={x.icon} label={x.label} keystroke={x.keystroke} /> 
		})
		let style = { left: context.x + "px", top: context.y + "px" };
		return (
			<div className="RockContextMenu" style={style}>
				{menuitems}
			</div>
		)
	}
}

export class RockContextMenuItem extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
	}
	render() {
		let { icon, label, keystroke, selected, disabled, className, title } = this.props;
		if (label === "separator") {
			return <div className="RockContextMenuItemSeparator"></div>
		}
		return (
			<div className={"RockContextMenuItem" + (selected ? " RockContextMenuItemSelected" : " RockContextMenuItemUnselected") + (disabled ? " RockContextMenuItemDisabled" : "") + (className ? " " + className : "")} onClick={disabled ? null : this.props.onClick} title={title} >
				<div className="RockContextMenuItemIcon">{icon}</div>
				<div className="RockContextMenuItemLabel">{label}</div>
				<div className="RockContextMenuItemKey">{keystroke}</div>
			</div>
		)
	}
}

class DeleteHandler {
	constructor(container, onDelete) {
		this.container = container;
		this.onDelete = onDelete;
	}
	enable = () => {
		this.container.addEventListener('keyup', this._onKey, false);
		return this;
	}
	disable = () => {
		this.container.removeEventListener('keyup', this._onKey);
	}
	_onKey = (e) => {
		e = e || window.event;
		if (e.which === 127 || e.keyCode === 127 || e.key === "Delete") {
			this.onDelete();
		}
	}
};
class DragResizeWindow {
	constructor(container_id, classname, att, onDone) {
		this.container_id = container_id;
		this.att = att || "left";
		this.side = "left";
		this.RESIZABLE_CLASSNAME = classname;
		this.onDone = onDone;
		this.MIN_WIDTH = 50;
		this.MOUSE_FOOTPRINT = 20;
	}

	enable = () => {
		document.body.addEventListener('mousemove', this._onMove, false);
		document.body.addEventListener('mousedown', this._onDown, false);
		document.body.addEventListener('touchstart', this._onDown, false);
		return this;
	}
	disable = () => {
		document.body.addEventListener('mousemove', this._onMove, false);
		document.body.removeEventListener('mousedown', this._onDown);
		document.body.removeEventListener('touchstart', this._onDown);
	}
	_onMove = (e) => {
		let pos = ZUtil.getMousePositionXY(e, document.body);
		if (this._resizing && this._element) {
			// TODO: right side
//console.log("resizing window this._element.offsetWidth=" + this._element.offsetLeft);
			let delta = pos.x - this._last_pos.x;
			if (this.att === "marginLeft" || this.att === "left") {
				delta = -delta;
			}
			let w = this._element.offsetWidth + delta;
			let left = this._element.offsetLeft - delta;
//console.log("TO Be =" + left);
			if (w > this.MIN_WIDTH) {
				if (this.att === "marginLeft") {
					this._element.style.marginLeft = 100 * left/this.container_width + "%";
				} else if (this.att === "left") {
					this._element.style.left = 100 * left/this.container_width + "%";
				}
				this._element.style.width = 100* w/this.container_width + "%";
				let dependent_id = this._element.getAttribute("data-dependent-resizable-panel-id");
//console.log("dependent_id=" + dependent_id);
				if (dependent_id) {
					let dependent = document.getElementById(dependent_id);
					dependent.style.width = 100 * (dependent.offsetWidth - delta)/this.container_width + "%";
				}
			}
			this._last_pos = pos;
			e.preventDefault();
		} else {
			//this._element = ZUtil.pick(this.RESIZABLE_CLASSNAME, pos.x, pos.y);
			this._element = ZUtil.smartPick(document.body, this.RESIZABLE_CLASSNAME, pos.x, pos.y);
			if (this._element) {
//console.error("FOUND drag resize panel; " + this._element.classname);
				this._element = this._element.element;
    				let rect = this._element.getBoundingClientRect();
//console.log("pos.x=" + pos.x);
//console.log("rect.left=" + rect.left);
//console.log("rect.width=" + rect.width);
//console.log("side=" + this.side);
				if ((this.side === "left" && pos.x - rect.left < this.MOUSE_FOOTPRINT)
					|| (this.side === "right" && rect.width - pos.x < this.MOUSE_FOOTPRINT)) {
					if (this._cursor_element) {
						this._cursor_element.style.cursor = "default";
					}
					this._cursor_element = ZUtil.pickTopElement(this._element, pos.x, pos.y);
					if (this._cursor_element) {
						this._cursor_element.style.cursor = "ew-resize";
					}
//console.error("FOUND left rag resize panel edge");
					this._resizable = true;
					this._last_pos = pos;
					e.preventDefault();
				} else {
					if (this._cursor_element) {
						this._cursor_element.style.cursor = "default";
					}
					this._cursor_element = null;
					this._resizable = false;
				}
			} else {
				this._resizable = false;
				if (this._cursor_element) {
					this._cursor_element.style.cursor = "default";
				}
				this._cursor_element = null;
			}
		}
	}
    _onDown = (e) => {
	if (this._resizable) {
//console.log("ondown drag resize window");
		this.container_width = document.getElementById(this.container_id).offsetWidth;
        	this._last_pos = ZUtil.getMousePositionXY(e, document.body);
		this._resizing = true;
		this._element = null;
	}
        if (!e.touches) {
            document.addEventListener('mouseup', this._onMouseUp, false);

        } else if (e.touches.length === 1) {
            document.addEventListener('touchmove', this._onMove, false);
            document.addEventListener('touchend', this._onTouchEnd, false);
        }
    }
    _onUp = () => {
	if (this._resizing && this.onDone) {
		this._resizing = false;
		this.onDone(this._element);
	}
	this._resizing = false;
	this._element = null;
    }
    _onMouseUp = () => {
        this._onUp();
        document.body.removeEventListener('mouseup', this._onMouseUp, false);
    }
    _onTouchEnd = () => {
        this._onUp();
        document.body.removeEventListener('touchmove', this._onMove);
        document.body.removeEventListener('touchend', this._onTouchEnd);
    }
	
};




export var RockSanityCheck = {
	init(service) {
		this.compileds = {};
		ZLog.debug("RockSanityCheck this.compileds=" + this.compileds);
		// allow custom architectures on any node
		let nodes = AMC.getFlattenedService(service);
		let arcs = nodes.filter( n => n.architecture ).map( n => { return { arc: n.architecture, container: n } });
nodes.forEach( n => {
if (!ZProps.get(n.type)) {
ZLog.error("type not downloaded with bundle: " + n.type);
}});
		let type_arcs = nodes.map( n => { return { arc: ZProps.get(n.type) ? ZProps.get(n.type).architecture : null, container: n } }).filter( ta => ta.arc );
		
		ZLog.debug("ZProps.get(architectures)=", { type_arcs: type_arcs });
		type_arcs.concat(arcs).forEach( a => this._processArchitecture(a) );
	},
	checkInsertBefore(container, newnode, oldnode) {
		let index_of_new_node = container.nodes.findIndex( n => n.uri === oldnode.uri );
		ZLog.debug("RockSanityCheck checking insert before at: " + index_of_new_node);
		return this._sanityCheckNewNode(container, newnode, index_of_new_node, this.compileds[container.uri]);
	},
	checkInsertAfter(container, newnode, oldnode) {
		let index_of_old_node = container.nodes.findIndex( n => n.uri === oldnode.uri );
		let index_of_new_node = index_of_old_node === container.nodes.length ? -1 : index_of_old_node + 1;
		ZLog.debug("RockSanityCheck checking insert after at: " + index_of_new_node);
		return this._sanityCheckNewNode(container, newnode, index_of_new_node, this.compileds[container.uri]);
	},
	checkSpecialReplace(container, newnode, oldnode) {
		if (newnode.kind === "dataset" && oldnode.kind === "datasource") {
			return null;
		}
		ZLog.debug("RockSanityCheck checkSpecialReplace - not allowed to replace this node: " + newnode.kind + " != " + oldnode.kind);
		return "not allowed to replace this node";
	},
	checkSelectedReplace(container, newnode, oldnode) {
		if (newnode.kind === oldnode.kind) {
			return null;
		}
		ZLog.debug("RockSanityCheck checkSelectedReplace - not allowed to replace this node: " + newnode.kind + " != " + oldnode.kind);
		return "not allowed to replace this node";
	},
	checkDelete(container, oldnode) {
		let index_of_old_node = container.nodes.findIndex( n => n.uri === oldnode.uri );
		return this._sanityCheckDeleteNode(container, oldnode, index_of_old_node, this.compileds[container.uri]);
	},
	_sanityCheckNewNode(container, newnode, index, compiled) {
		ZLog.debug("RockSanityCheck index=" + index);
		if (!compiled) {
			ZLog.warn("RockSanityCheck - container has no compliled: " + container.uri);
			return "not allowed in this position";
		}			
		let which = index;
		if (compiled.kinds[index]) {
		} else if (index === -1 || index >= container.nodes.length) {
			which = "last";
		} else {
			which = "middle";
		}
		ZLog.debug("RockSanityCheck which=" + which);
		// check position
		ZLog.debug("RockSanityCheck kinds which=" + compiled.kinds[which]);
		if (compiled.kinds[which].indexOf(newnode.kind) === -1) {
			ZLog.debug("Kind " + newnode.kind + " not allowed at this position " + which);
			return "not allowed in this position";
		}
		// check count allowed
		let current = container.nodes.reduce( (total, node) => node.kind === newnode.kind ? total + 1 : total, 0 );
		ZLog.debug("RockSanityCheck counts which=", { counts: compiled.counts[which] });
		if (compiled.counts[which].max < current + 1) {
			ZLog.debug("Kind " + newnode.kind + " already has max number allowed at this position " + current);
			return "too many for this container";
		}
		return null;
	},
	_sanityCheckDeleteNode(container, node, index, compiled) {
		let which = index;
		if (compiled.kinds[index]) {
		} else if (index === -1) {
			which = "last";
		} else {
			which = "middle";
		}
		let current = container.nodes.reduce( (total, n) => n.kind === node.kind ? total + 1 : total, 0 );
		if (compiled.counts[which].min > current - 1) {
			ZLog.debug("Kind " + node.kind + " already has min number allowed at this position " + current);
			return "too few to delete this node";
		}
		return null;
	},
	// allowed: 0, 1, 0+, 1+
	_processArchitecture(architecture) {
		let { arc, container } = architecture;
		ZLog.debug("arc=" + arc + ", container= " + container, { arc: arc, container: container });
		if (typeof arc === "string") {
			arc = ZProps.get(arc);
		}
		let list = arc.template;
		let compiled = { kinds: {}, counts: {} }
		let rule, min, max, kinds;
		for (let i = 0; i < list.length; ++i) {
			rule = list[i].rules;
			min = parseInt(rule[0], 10);
			kinds = list[i].kind.replace(/\s+/g, "").split(",");
			if (rule.length === 1) {
				max = min;
				compiled.counts[i] = { min, max };
				compiled.kinds[i] = kinds;
			} else {
				max = Number.MAX_SAFE_INTEGER;
				compiled.kinds.middle = kinds;
				compiled.counts.middle = { min, max };
				break;
			}
		}
		let last = list[list.length - 1];
		compiled.kinds.last = last.kind.replace(/\s+/g, "").split(",");
		rule = last.rules;
		min = parseInt(rule[0], 10);
		max = rule.length === 1 ? min : Number.MAX_SAFE_INTEGER;
		compiled.counts.last = { min, max }

		this.compileds[container.uri] = compiled;
	},
	validate(service) {
		let errors = RockSanityCheck.validateComponentProperties(service);
		errors = errors.concat(RockSanityCheck.validateFrameworkAndStackChoices(service, true));
		errors = errors.concat(RockSanityCheck.validateComponentsExist(service));
		errors = errors.concat(RockSanityCheck.validateComponentInputsAgainstCallerOutputs(service));
		return errors;
	},
	validateComponentProperties(service) {
		ZLog.debug("validateComponentProperties");
		let errors = [];
		let nodes = AMC.getFlattenedService(service);
		nodes.forEach( node => {
			let spec = ZProps.get(node.type + ".spec");
			if (!spec) {
				ZLog.warn("No spec found for " + node.type + ".spec");
			} else {
				// TODO validate if feature that it matches a feature of dataset
				(spec.fields || []).forEach( f => {
					if (f.required && !node[f.field] && !f["default"]) {
						errors.push({ uri: node.uri, field: f.name, message: "A value is required for " + f.name });
					}
				} );
			}
		});
		ZLog.debug("validateComponentProperties", { errors: errors });
		return errors;
	},
	validateComponentsExist(service) {
		ZLog.debug("validateComponentsExist");
		let errors = [];
		let nodes = AMC.getFlattenedService(service);
		nodes.forEach( node => {
			ZLog.debug("checking node.type if found: " + node.type);
			if (!ZProps.get(node.type)) {
				errors.push({ uri: node.uri, message: "Component type not found" });
			} else if (AMCConstants.COMPONENTS_WITHOUT_SPEC_OR_IMP.indexOf(node.kind) === -1) {
				if (!ZProps.get(node.type + ".spec")) {
					errors.push({ uri: node.uri, message: "Component specificaton not found" });
				//} else if (!ZProps.get(node.type + ".imp")) {
					//errors.push({ uri: node.uri, message: "Component implementation not found" });
				}
			}
		});
		ZLog.debug("validateComponentsExist errors found: ", {errors: errors });
		return errors;
	},
	validateComponentInputsAgainstCallerOutputs(service) {
		ZLog.debug("validateComponentInputsAgainstCallerOutputs");
		let errors = [];
		let pipelines = AMC.getFlattenedService(service).filter( n => n.kind === "pipeline" );
		for (let i = 0; i < pipelines.length; ++i) {
			let nodes = pipelines[i].nodes;
			for (let j = 1; j < nodes.length; ++j) {
				let input = ZProps.get(nodes[j].type);
				if (!input) {
					errors.push({ uri: nodes[j].uri, message: "Component type not found" });
					continue;
				}
				let output = ZProps.get(nodes[j-1].type);
				if (!output) {
					errors.push({ uri: nodes[j-1].uri, message: "Component type not found" });
					continue;
				}
				let inputs = input.inputs;
				let outputs = output.outputs;
				// require at least 1 input matching an output
				if (!inputs) {
					errors.push({ uri: nodes[j].uri, message: "Component has no inputs" });
					continue;
				}
				let matched = false;
				for (let k = 0; k < inputs.length; ++k) {
					if (outputs.indexOf(inputs[k]) !== -1) {
						matched = true;
						break;
					}
				}
				if (!matched) {
					errors.push({ uri: nodes[j].uri, message: "No input matches any caller output: " + inputs + " != " + outputs });
				}
			}
		}

		ZLog.debug("validateComponentInputsAgainstCallerOutputs errors found: ", {errors: errors });
		return errors;
	},
	validateFrameworkAndStackChoices(service, update_service_deployment_properties_if_necessary) {
		ZLog.debug("validateFrameworkAndStackChoices");
		let errors = [];
		let nodes = AMC.getFlattenedService(service);
		let dependencies = [{ component: service.framework, dep: service.framework}]
			.concat((AMCConstants.FRAMEWORK_DEPENDENCIES[service.framework] || []).map( d => { return { component: service.framework, dep: d } }))
			.concat(AMCConstants.ATMSERVICE_DEPENDENCIES.map( d => { return { component: "API", dep: d } }))
			.concat( nodes.reduce( (libs, node) => libs = libs.concat( 
				ZProps.get(node.type) ? (ZProps.get(node.type).dependencies || []).map( d => { return { component: node.type, dep: d } }) : [] ), [] ));
		dependencies = ZUtil.uniqBy(dependencies, "dep");

		let supported_frameworks = AMCConstants.COMMON_SPECS.service.find( f => f.field === "framework" ).choices;
		let supported_stacks = AMCConstants.COMMON_SPECS.service.find( f => f.field === "stacks" ).choices;

		ZLog.debug("validateFrameworkAndStackChoices", { dependencies: dependencies });

		let required_frameworks = [];
		let required_stacks = [];
		let unsupported_stacks = [];
		dependencies.forEach( req => {
			if (supported_frameworks.indexOf(req.dep) !== -1) {
				required_frameworks.push(req.dep);
			} else if (supported_stacks.indexOf(req.dep) !== -1) {
				required_stacks.push(req);
			} else {
				unsupported_stacks.push(req);
			}
		});
		required_frameworks = ZUtil.uniq(required_frameworks);
		ZLog.debug("validateFrameworkAndStackChoices", { required_frameworks: required_frameworks });
		if (required_frameworks.length > 1 && required_frameworks.indexOf("sklearn") !== -1) {
			required_frameworks.splice(required_frameworks.indexOf("sklearn"), 1);
			required_stacks.push({ component: "a component", dep: "sklearn" });
			required_stacks = required_stacks.concat(
				(AMCConstants.FRAMEWORK_DEPENDENCIES["sklearn"] || []).map( d => { return { component: "sklearn", dep: d } } ));
		}
		required_stacks = ZUtil.uniqBy(required_stacks, "dep");
		unsupported_stacks = ZUtil.uniqBy(unsupported_stacks, "dep");
		// sklearn is often used as a library of support routines with other frameworks
		if (required_frameworks.length > 1) {
			errors.push({ uri: service.uri, message: "Cannot support multiple frameworks within one service: " + required_frameworks.join(", ") });
		} else if (unsupported_stacks.length > 0) {
			errors.push({ uri: service.uri, message: `Using ${required_frameworks[0]}, no support for library stacks: ${unsupported_stacks.map( req => req.dep + " (required by " + req.component + ")").join(", ")}` });
		}
		if (errors.length > 0) {
			errors.push({ uri: service.uri, message: "Unable to find combinations of framework and stacks to support the libraries of this service's component dependencies" });
		}
		if (errors.length === 0 && update_service_deployment_properties_if_necessary) {
			if (service.framework !== required_frameworks[0] || (service.stacks || []).sort().join(",") !== required_stacks.map( req => req.dep).sort().join(",")) {
				AMC.update(service.uri, { framework: required_frameworks[0], stacks: required_stacks.map( req => req.dep) });
				ZLog.debug("validateFrameworkAndStackChoices - updated service framework and stacks", { framework: service.framework, stacks: service.stacks });
			}
		}
		errors = ZUtil.uniqBy(errors, "message");
		ZLog.debug("validateFrameworkAndStackChoices", { errors: errors });
		return errors;
	}
}





// WEBPACK FOOTER //
// ./src/rs.js